import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import ContactForm from './ContactForm';

function IconMail({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 6h16v12H4V6z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M4 7l8 6 8-6"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconPhone({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6.5 4h3l1.5 4-2 1.5c1 2 3.5 4.5 5.5 5.5L17 13l4 1.5v3a2 2 0 01-2.2 2C8.5 18.5 3.5 10.5 4.5 6.2A2 2 0 016.5 4z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconMap({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 21s7-4.5 7-11a7 7 0 10-14 0c0 6.5 7 11 7 11z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="10" r="2.5" fill="currentColor" />
    </svg>
  );
}

const CARD_CONFIG = [
  { key: 'email', icon: IconMail, labelKey: 'contact.emailLabel', valueKey: 'contact.emailValue' },
  { key: 'phone', icon: IconPhone, labelKey: 'contact.phoneLabel', valueKey: 'contact.phoneValue' },
  { key: 'address', icon: IconMap, labelKey: 'contact.addressLabel', valueKey: 'contact.addressValue' },
];

function ContactCardValue({ cardKey, value }) {
  if (cardKey === 'email') {
    return (
      <p className="contact-page__card-value">
        <a href={`mailto:${value}`} className="contact-page__card-link">
          {value}
        </a>
      </p>
    );
  }
  if (cardKey === 'phone') {
    const tel = value.replace(/\s/g, '');
    return (
      <p className="contact-page__card-value">
        <a href={`tel:${tel}`} className="contact-page__card-link">
          {value}
        </a>
      </p>
    );
  }
  return <p className="contact-page__card-value">{value}</p>;
}

/**
 * @param {{ showBackLink?: boolean }} props
 */
export default function ContactPageContent({ showBackLink = false }) {
  const { t } = useLanguage();

  return (
    <>
      <header className="contact-page__hero">
        <div className="contact-page__hero-inner">
          <p className="contact-page__eyebrow">{t('contactPage.eyebrow')}</p>
          <h1 className="contact-page__title">{t('contactPage.title')}</h1>
          <p className="contact-page__lead">{t('contactPage.lead')}</p>
        </div>
      </header>

      <div className="contact-page__inner">
        <div className="contact-page__split">
          <div className="contact-page__cards-col">
            {CARD_CONFIG.map(({ key, icon: Icon, labelKey, valueKey }) => (
              <article key={key} className="contact-page__card">
                <div className="contact-page__card-icon" aria-hidden="true">
                  <Icon className="contact-page__card-svg" />
                </div>
                <h2 className="contact-page__card-label">{t(labelKey)}</h2>
                <ContactCardValue cardKey={key} value={t(valueKey)} />
              </article>
            ))}
          </div>
          <div className="contact-page__form-col">
            <ContactForm />
          </div>
        </div>

        {showBackLink ? (
          <p className="contact-page__back">
            <Link to="/">{t('legal.backToHome')}</Link>
          </p>
        ) : null}
      </div>
    </>
  );
}
